import { myGet, myPost, handleGetError, handlePostError } from '../utils/myAxios'
import { servAddr } from '../servAddr'
import { store } from '../index'

export function fetchSets(sets) {
  const state = store.getState();
  const model = state.auth.rights[sets + '_s_get'] === 1 ? (sets + '_s') : sets;
  return dispatch => {
    myGet(dispatch, servAddr + model).then((response) => {
      dispatch({type: "FETCH_"+sets.toUpperCase()+"S", payload: response.data});
    }, err => {
      handleGetError(dispatch, err);
    })
  }
}

export function editSets(sets, data, cb = () => {}) {
  const state = store.getState();
  const model = state.auth.rights[sets + '_s_post'] === 1 ? (sets + '_s') : sets;
  return dispatch => {
    myPost(dispatch, servAddr + model, {data}).then((response) => {
      if (data.hasOwnProperty(sets + '_id')) {
        cb();
        dispatch({
          type: "EDIT_"+sets.toUpperCase(),
          payload: data
        });
      }
      else {
        dispatch({
          type: "EDIT_"+sets.toUpperCase(),
          payload: {
            ...data,
            [sets+"_id"]:response.data.id
          }
        });
        cb(null, response.data.id);
      }
    }, err => {
      handlePostError(dispatch, err, cb);
    });
  }
}

export const addSets = editSets;

export function sortSets(sets,sort){
  return {
    type: 'SORT_'+sets.toUpperCase()+'S',
    sort: sort
  };
}

export function searchSets(sets,search){
  return {
    type: 'SEARCH_'+sets.toUpperCase()+'S',
    search: search
  };
}

export function filterSets(sets,filter){
  return {
    type: 'FILTER_'+sets.toUpperCase()+'S',
    filter: filter
  };
}



// WEBPACK FOOTER //
// ./src/actions/settings.js